export * from './pick-up-tip-selector';
